import request from '../../utils/request'

// 获取领券列表分页

export function getCouponList(data) {
  return request({
    url: '/sc/ticketMain/api/factQylq/myPage',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
//  获取领券详情
export function getCouponDetail(data) {
  return request({
    url: '/sc/ticketMain/api/factQyjbxxb/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
// 我的对付券
export function getMyCoupon(data) {
  return request({
    url: '/sc/ticketMain/api/factDfsqxx/pageTab',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 获取额度
export function getQuota(data) {
  return request({
    url: '/sc/ticketMain/api/factEdgl/page',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 获取企业详情信息
export function getEnterpriseInfo(data) {
  return request({
    url: '/sc/ticketMain/api/factQyjbxxb/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 更新企业信息
export function updateEnterpriseInfo(data) {
  return request({
    url: '/sc/ticketMain/api/factQyjbxxb/update',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}
